// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20801-新增游泳者 POST /app/v1/swimmer/add */
export async function addSwimmer(
  body: API.SwimSwimmerAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/app/v1/swimmer/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20803-删除游泳者 DELETE /app/v1/swimmer/delete/${param0} */
export async function deleteSwimmer(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSwimmerParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/app/v1/swimmer/delete/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 20805-游泳者详情 GET /app/v1/swimmer/detail/${param0} */
export async function getSwimmerDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimmerDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimSwimmerDetailVo>(
    `/app/v1/swimmer/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20810-删除紧急联系人 DELETE /app/v1/swimmer/emergency/delete/${param0}/${param1} */
export async function deleteEmergencyContact(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteEmergencyContactParams,
  options?: { [key: string]: any }
) {
  const { swimmerId: param0, contactId: param1, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(
    `/app/v1/swimmer/emergency/delete/${param0}/${param1}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20808-游泳者紧急联系人详情 GET /app/v1/swimmer/emergency/detail/${param0}/${param1} */
export async function getEmergencyContactDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getEmergencyContactDetailParams,
  options?: { [key: string]: any }
) {
  const { swimmerId: param0, contactId: param1, ...queryParams } = params;
  return request<API.YmResultVOEmergencyContactRespVO>(
    `/app/v1/swimmer/emergency/detail/${param0}/${param1}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20807-游泳者紧急联系人列表 GET /app/v1/swimmer/emergency/list/${param0} */
export async function getEmergencyContactList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getEmergencyContactListParams,
  options?: { [key: string]: any }
) {
  const { swimmerId: param0, ...queryParams } = params;
  return request<API.YmResultVOListEmergencyContactRespVO>(
    `/app/v1/swimmer/emergency/list/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20809-新增/更新紧急联系人 POST /app/v1/swimmer/emergency/save */
export async function saveEmergencyContact(
  body: API.EmergencyContactSaveReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/swimmer/emergency/save", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20804-游泳者分页列表 POST /app/v1/swimmer/list */
export async function getSwimmerList(
  body: API.SwimSwimmerListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimSwimmerListVo>(
    "/app/v1/swimmer/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20806-游泳者简单列表（不分页） POST /app/v1/swimmer/simpleList */
export async function getSwimmerSimpleList(
  body: API.SwimSwimmerSimpleListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimSwimmerListVo>(
    "/app/v1/swimmer/simpleList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20802-修改游泳者 POST /app/v1/swimmer/update */
export async function updateSwimmer(
  body: API.SwimSwimmerUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/swimmer/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
